import { Box, IconButton, Modal as ModalMui, styled as styledMui } from "@mui/material";
import { XIcon } from "@phosphor-icons/react/dist/csr/X";
import { FC, ReactNode } from "react";

const ModalHeader = styledMui("div")({
  display: "flex",
  justifyContent: "space-between",
});

const ModalContent = styledMui(Box, {
  shouldForwardProp: (prop) => prop !== "width",
})<{ width: string }>(({ width, theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: width,
  backgroundColor: theme.palette.surfaceLight10.main,
  border: `2px solid ${theme.palette.surfaceDark50.main}`,
  boxShadow: "24",
  paddingRight: "10px",
  paddingLeft: "20px",
  paddingBottom: "5px",
}));

const ModalBody = styledMui("div")({
  display: "flex",
  marginTop: 15,
  marginBottom: 15,

  overflowY: "scroll",
  maxHeight: "50vh",
});

const ModalFooter = styledMui("div")({
  display: "flex",
  justifyContent: "flex-end",
});

interface IModalProps {
  open: boolean;
  onClose?: () => void;
  body: ReactNode;
  footer: ReactNode;
  header?: ReactNode;
  modalWidth?: string;
  className?: string;
}

const Modal: FC<IModalProps> = ({ open, onClose, body, footer, header, modalWidth = "50%", className = "" }) => {
  return (
    <ModalMui
      open={open}
      onClose={() => onClose && onClose()}
      // one more than the editor
      sx={{
        zIndex: 10001,
      }}
      className={className}
      data-cy="modal"
    >
      <ModalContent width={modalWidth}>
        <ModalHeader data-cy="modal-header">
          {header}
          <IconButton
            sx={{
              marginLeft: "auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "40px",
              height: "40px",
            }}
          >
            {onClose && <XIcon onClick={() => onClose()} />}
          </IconButton>
        </ModalHeader>
        <ModalBody data-cy="modal-body">{body}</ModalBody>
        <ModalFooter data-cy="modal-footer">{footer}</ModalFooter>
      </ModalContent>
    </ModalMui>
  );
};

export { Modal };
